// RsiWidget/RsiCache.js
// Normal Cache — CacheBase2, singleton export (Engine Pattern rk=f03ae8b6).
// Holds the latest RSI slots per asset per period, keyed on each item's rk ("{ems}_{sid}_{period}").
// No custom overrides needed for now — base getAll/addOrUpdate/get(rk) cover everything.
//
// SAME ISSUE AS Sma200Cache (rk=896be0200668464897d0dc11b9ae1f47): no prune-on-push —
// once RMQ starts pushing new slots per asset per day, this grows unbounded. Deferred on purpose.
import CacheBase2 from '../../../services/engines/CacheBase2';

const _name = 'RsiCache';

class RsiCache extends CacheBase2 {
    initialize() {
        this._name = _name;
    }
}

const rsiCache = new RsiCache();
export default rsiCache;
